export function hasPageEscapeResetAction({
  toolbarOpen = false,
  searchQuery = "",
  sortState = null,
  extraResetAvailable = false
}) {
  return Boolean(toolbarOpen || String(searchQuery ?? "").trim() || sortState || extraResetAvailable);
}

export function handlePageEscapeReset({
  searchQuery = "",
  setSearchQuery,
  sortState = null,
  setSortState,
  extraResetAvailable = false,
  onExtraReset,
  onResetApplied
}) {
  if (String(searchQuery ?? "").trim()) {
    setSearchQuery?.("");
    onResetApplied?.();
    return true;
  }

  if (sortState) {
    setSortState?.(null);
    onResetApplied?.();
    return true;
  }

  if (extraResetAvailable) {
    onExtraReset?.();
    onResetApplied?.();
    return true;
  }

  return false;
}
